import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import { profileDetailsRoute } from './profileDetails.route';
import { profileEditRoute } from './profileEdit.route';
import { profileRolesRoute } from './profileRoles.route';

export const profileRoute: RouteConfig = {
  path: ':profileId',
  component: () => import(/* webpackChunkName: "Profile" */ '@/views/mainRoute/profile/Profile.vue'),
  children: [profileDetailsRoute('profile'), profileEditRoute('profileEdit'), profileRolesRoute],
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'Profil',
      name: 'profile'
    }
  },
  props: {
    tabs: [
      { title: 'Profil', route: { name: 'profile' } },
      { title: 'Edycja', route: { name: 'profileEdit' } },
      { title: 'Role', route: { name: 'profileRoles' } }
    ]
  },

  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('profile/setId', tryParseInt(to.params.profileId));
    store
      .dispatch('profile/get')
      .then(profile => {
        profileRoute.meta.breadcrumb.title = profile.email;
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: Errors.PROFILE_CANNOT_GET }));
  }
};
